import { useAppStore } from '@/store/appStore'
import { UserRole } from '@/types/index'

/**
 * Hook para gestionar permisos basados en roles
 */
export function usePermissions() {
  const { currentUser } = useAppStore()
  const role = currentUser?.role

  // Permisos administrativos completos
  const canManageUsers = role === 'admin'
  const canManageInventory = ['admin', 'cocina', 'cocinero'].includes(role || '')
  const canManageDevices = role === 'admin'
  const canViewLogs = role === 'admin' || role === 'supervisor'
  const canExportReports = role === 'admin'
  
  // Permisos operativos
  const canCreateSales = ['admin', 'capitan', 'mesero', 'bar', 'cocina', 'cocinero'].includes(role || '')
  const canModifyOrders = ['admin', 'capitan', 'mesero', 'cocina', 'cocinero'].includes(role || '')
  const canDeleteProducts = ['admin', 'cocina', 'cocinero'].includes(role || '')
  const canAccessKitchen = ['admin', 'cocina', 'cocinero', 'capitan', 'mesero'].includes(role || '')
  const canAccessBar = ['admin', 'bar'].includes(role || '')
  const canManageTables = ['admin', 'capitan'].includes(role || '')
  // Solo admin/capitan/supervisor acceden a monitor - mesero usa OrdersToServe
  const canAccessTableMonitor = canManageTables
  
  // Permisos de reportes
  const canViewReports = ['admin', 'supervisor'].includes(role || '')
  const canViewSalesReport = ['admin', 'supervisor'].includes(role || '')
  const canViewInventoryReport = ['admin', 'supervisor'].includes(role || '')
  const canViewEmployeeMetrics = role === 'admin'
  
  // Permisos financieros
  const canCloseCashRegister = role === 'admin'
  const canCloseRegister = role === 'admin'
  const canViewFinancialData = ['admin', 'supervisor'].includes(role || '')
  const canApplyDiscounts = ['admin', 'capitan'].includes(role || '')
  
  // Helper: verificar si tiene al menos uno de los roles
  const hasAnyRole = (roles: UserRole[]) => {
    return roles.includes(role as UserRole)
  }
  
  // Helper: verificar si es rol de solo lectura
  const isReadOnly = role === 'supervisor'

  return {
    // Permisos administrativos
    canManageUsers,
    canManageInventory,
    canManageDevices,
    canViewLogs,
    canExportReports,
    
    // Permisos operativos
    canCreateSales,
    canModifyOrders,
    canDeleteProducts,
    canAccessKitchen,
    canAccessBar,
    canManageTables,
    canAccessTableMonitor,
    
    // Permisos de reportes
    canViewReports,
    canViewSalesReport,
    canViewInventoryReport,
    canViewEmployeeMetrics,
    
    // Permisos financieros
    canCloseCashRegister,
    canCloseRegister,
    canViewFinancialData,
    canApplyDiscounts,
    
    // Helpers
    hasAnyRole,
    isReadOnly,
    currentRole: role,
    isAdmin: role === 'admin',
  }
}
